/**
 * MultilingualKeywordNoscript — REMOVED
 * Hidden keyword blocks are penalized by Google as keyword stuffing.
 */
export function MultilingualKeywordNoscript() {
  return null;
}
